import React, { Component } from 'react';
import ReactLoading from 'react-loading';

class Loader extends Component {
    render() {
        let loaderDiv = null;

        if (this.props.displayLoader) {
            loaderDiv = (
                <ReactLoading type="spin" color="#555" height={this.props.size ? this.props.size : 30} width={this.props.size ? this.props.size : 30} />
            );
        }

        return loaderDiv;
    }
}

export default Loader;



/** WEBPACK FOOTER **
 ** ./src/components/shared/loader.jsx
 **/